import React from "react";
import { useNavigate } from "react-router-dom";

function NotFound() {
    const navigate = useNavigate();

    return (
        <div style={{ textAlign: "center", padding: "80px 20px" }}>
            <h1 style={{ fontSize: "6rem", margin: 0 }}>404</h1>
            <h2>Page introuvable</h2>
            <p>La page que vous recherchez n'existe pas ou a été déplacée.</p>
            <button className="backtohome btn-redarrow" onClick={() => navigate("/")}>
                Retour à l'accueil
            </button>
        </div>
    );
}

export default NotFound;